import React from "react";
import Container from "@mui/material/Container";
import Bottomright from "../../../assets/images/first-page/bottom-right-gradient.svg";
import Topleft from "../../../assets/images/first-page/top-left-gradient.svg";
import {
    Typography,
    Box,
    Stack,
    Button,
} from "@mui/material";
import Logo from "../../../assets/images/common/logo.png";
import { useTheme } from '@mui/material/styles';
import { KeyboardBackspaceOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
const Privacypolicy = () => {
    const theme = useTheme()
    return (
        <>
            <Box
                className="welcome-page"
                sx={{ position: "relative", zIndex: "9999" }}
            >
                 <Container className="cabinetfont">
                    <Box display="flex" justifyContent="flex-start">

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<KeyboardBackspaceOutlined />}
                            sx={{
                                width: "120px",
                                height: "50px",
                                backgroundColor: "primary.main",
                                fontSize: "18px",
                                fontWeight: "500",
                                borderRadius: "50px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "10px 20px",
                            }}
                            component={Link}
                            to="/login"
                        >

                        </Button>
                    </Box>

                    <Stack
                        direction={"column"}
                        justifyContent={"start"}
                        alignItems={"start"}
                        marginLeft={"14%"}
                    >


                        <Box>
                            <img src={Logo} alt="logo" />
                        </Box>

                        <Box sx={{ width: { xs: '100%', md: "80%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "500" }}
                                fullWidth
                            >
                                Imagnce Pty Limited and AskLMS Privacy Policy
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>

                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: "30px",
                                    fontWeight: "500",
                                    mt: { xs: "16px", xl: "12px" },
                                    mb: { xs: "12px", xl: "28px" },
                                }}
                            >
                                31 January 2025
                            </Typography>
                        </Box>



                        <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "3px", xl: "6px" } }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: { xs: '15px', md: "20px" },
                                    fontWeight: "500",
                                    mb: { xs: "14px", xl: "24px" },
                                }}
                                fullWidth
                            >
                                Imagnce Pty Limited and AskLMS (together with our affiliates, “we”, “our” or “us”) respect your privacy and are strongly
                                committed to keeping secure any information we obtain from you or about you. This Privacy Policy describes our practices with respect to Personal Data that we collect from or about you when you use our website, applications, and services (collectively, “Services”).                            </Typography>


                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                1. Personal Data we collect
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: { xs: '15px', md: "20px" },
                                    fontWeight: "500",
                                    mb: { xs: "14px", xl: "24px" },
                                }}
                                fullWidth
                            >We collect personal data relating to you (“Personal Data”) as follows:
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "500" }}
                                fullWidth
                            >Personal Data You Provide

                            </Typography>
                            <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }} paddingTop={{ xs: "20px", xl: "40px" }} marginLeft={"30px"} >
                                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                    <b>Account Information:</b> Name, contact information, account credentials, date of birth, payment information, and transaction history.
                                </Typography>
                                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                    <b>User Content:</b> Any data you provide in input fields, including prompts, files, images, and audio.
                                </Typography>
                                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                    <b> Communication Information: </b>Messages you send via email or social media.

                                </Typography>
                                <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                    <b>  Other Information You Provide:</b> Data shared through events, surveys, or identity verification.
                                </Typography>

                            </Box>
                        </Box>

                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#CBD2E2", fontSize: "30px", fontWeight: "400" }}
                                fullWidth
                            >
                                Personal Data We Receive from Your Use of the Services
                            </Typography>
                        </Box>
                        <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }} paddingTop={{ xs: "20px", xl: "40px" }} marginLeft={"30px"} >
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b> Usage Data: </b>Interaction with services, device details, location, and browsing preferences.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b>Device Information:</b> Operating system, browser, device identifiers.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b>  Location Information:</b> IP-based location tracking.

                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b>  Cookies and Similar Technologies:</b> Used for session preferences and service improvements.
                            </Typography>

                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                2. How we use Personal Data
                            </Typography>
                        </Box>
                        <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }} paddingTop={{ xs: "20px", xl: "40px" }} marginLeft={"30px"} >
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                To provide, analyze, and maintain our Services.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                To improve and develop new product features.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                To communicate with you regarding updates.

                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                To prevent fraud and ensure security.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                To comply with legal obligations.
                            </Typography>

                        </Box>

                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                3. Disclosure of Personal Data
                            </Typography>
                        </Box>
                        <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }} paddingTop={{ xs: "20px", xl: "40px" }} marginLeft={"30px"} >
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b>  Vendors and Service Providers:</b> Hosting, customer service, and analytics.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b> Business Transfers:</b> In case of mergers or acquisitions.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b> Government Authorities:</b> Compliance with legal obligations.

                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                <b>  Affiliates: </b>Shared within our affiliated entities
                            </Typography>

                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                4. Retention
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: { xs: '15px', md: "20px" },
                                    fontWeight: "500",
                                    mb: { xs: "14px", xl: "24px" },
                                }}
                                fullWidth
                            >
                                We retain Personal Data as long as necessary to provide our services or comply with legal obligations.


                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                5. Your Rights
                            </Typography>
                        </Box>
                        <Box component="ul" sx={{ pl: 3, color: "#CBD2E2" }} paddingTop={{ xs: "20px", xl: "40px" }} marginLeft={"30px"} >
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                Access, delete, or update your Personal Data.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                Restrict or object to processing.
                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                Withdraw consent at any time

                            </Typography>
                            <Typography component="li" sx={{ fontSize: { xs: '15px', md: "18px" } }}>
                                Lodge a complaint with your local authority.
                            </Typography>

                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                6. Children
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: { xs: '15px', md: "20px" },
                                    fontWeight: "500",
                                    mb: { xs: "14px", xl: "24px" },
                                }}
                                fullWidth
                            >
                                Our Services are not directed at children under 13. Users under 18 require parental consent.
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                7. Security
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: { xs: '15px', md: "20px" },
                                    fontWeight: "500",
                                    mb: { xs: "14px", xl: "24px" },
                                }}
                                fullWidth
                            >
                                We use commercially reasonable security measures but cannot guarantee absolute security.

                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: "60%" }, paddingTop: { xs: "40px", xl: "80px" } }}>
                            <Typography
                                variant="h1"
                                sx={{ color: "#fff", fontSize: { xs: '28px', md: "40px" }, fontWeight: "400" }}
                                fullWidth
                            >
                                8. Additional U.S. State Disclosures
                            </Typography>
                        </Box>
                        <Box sx={{ width: { xs: "100%", md: "90%" }, paddingTop: { xs: "20px", xl: "40px" } }}>
                            <Typography
                                variant="h1"
                                sx={{
                                    color: "#CBD2E2",
                                    fontSize: { xs: '15px', md: "20px" },
                                    fontWeight: "500",
                                    mb: { xs: "14px", xl: "24px" },
                                }}
                                fullWidth
                            >
                                Specific privacy rights vary by state. Contact us for more details.

                            </Typography>
                        </Box>

                    </Stack>
                </Container>

                <Box sx={{
                    position: "absolute", top: 0, left: 0, zIndex: "-1", "& > .child": {
                        width: { xs: '300px', md: 'auto' },
                    },
                }}>
                    <img src={Topleft} alt="gradient" className="child" />
                </Box>
                <Box sx={{
                    position: "absolute", bottom: 0, right: 0, zIndex: "-1", "& > .child": {
                        width: { xs: '300px', md: 'auto' },
                    },
                }}>
                    <img src={Bottomright} alt="gradient" className="child" />
                </Box>

            </Box>
        </>
    );

}


export default Privacypolicy